'use strict'
export function formatDateTime(str) {
    if (!str || str.length != 14) {
        return str
    }
    let y = str.substring(0, 4)
    let M = str.substring(4, 6)
    let d = str.substring(6, 8)
    let h = str.substring(8, 10)
    let m = str.substring(10, 12)
    let s = str.substring(12, 14)
    return `${y}-${M}-${d} ${h}:${m}:${s}`
}